import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import debounce from 'lodash/debounce';
/**
 * A utility to batch invocations to a function.
 * All the batched requests with their arguments & returned promises are stored in the BatchMap.
 * The batched method needs a distinct `id` argument followed by the request object.
 *
 * @param {function} argumentResolver - Iterates on the BatchMap and generates the final request object which needs to be passed to the API.
 * @param {function} finalFn - The API which needs to be invoked.
 * @param {function} successfulResponseMapper - For the given id and batched successful response it extracts the response for the individual call.
 * @param {number | optional} debounceTime - The time till which the debouncing should happen.
 *
 * @typeParam {T} - It is the argument taken by the batched function.
 * @typeParam {R} - The response returned by the final function.
 * @typeParam {U} - The response type for individual method invocation.
 */
export var batchMethod = function batchMethod(argumentResolver, finalFn, successfulResponseMapper) {
  var debounceTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
  var batchMap = {};
  var timedFn = debounce(function () {
    var inFlightRequestsMap = _objectSpread({}, batchMap);
    var keys = Object.keys(inFlightRequestsMap);
    var args = keys.map(function (key) {
      return inFlightRequestsMap[key].arg;
    });
    finalFn(argumentResolver(args)).then(function (response) {
      keys.forEach(function (key) {
        inFlightRequestsMap[key].resolve(successfulResponseMapper(response, key));
      });
    }).catch(function () {
      keys.forEach(function (product) {
        inFlightRequestsMap[product].reject();
      });
    }).finally(function () {
      return keys.forEach(function (key) {
        return delete batchMap[key];
      });
    });
  }, debounceTime);
  return function (id, arg) {
    var promise = new Promise(function (resolve, reject) {
      batchMap[id] = {
        resolve: resolve,
        reject: reject,
        arg: arg
      };
    });
    timedFn();
    return promise;
  };
};